<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="details.details_background_img"
        alt=""
      >
      <p class="Title">
        {{details.details_title_cn}}
      </p>
    </div>
    <section class="sectionContent">
      <!-- <div class="labar">
        <span v-for="(item,i) of tabbar" :key="i">{{item}} ></span>
       
        <span>{{details.details_title_cn}}</span>
      </div> -->
      <labars-bread></labars-bread>
      <div
        class="details"
        v-html="details.content_cn"
      >

      </div>
    </section>
  </div>
</template>
<script>
import { overviewDetails } from "@/api/Overview";
import LabarsBread from "../../layout/LabarsBread";
export default {
  name: "Overview",
  data() {
    return {
      tabbar: [],
      details: []
    };
  },
  components: {
    LabarsBread
  },
  created() {
    var sid = this.$route.query.sid;
    overviewDetails({
      overview_id: sid
    }).then(res => {
      this.details = res.data.info;
      // console.log(res.data);
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;

  padding: 0.1px 0;
  background: #f5f5f5;
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(160px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
}
.sectionContent {
  width: px2Rem(1300px);
  margin: auto;
  .details {
    padding: px2Rem(35px) px2Rem(30px);
    margin-bottom: px2Rem(51px);
    background: rgba(255, 255, 255, 1);
    font-size: px2Rem(30px);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: px2Rem(40px);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/OverviewAndWelcome/OverviewDetail.vue